import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';

const withCart = Component =>
  graphql(
    gql`
  query withCart {
    cart {
      ...${Component.displayName}
    }
  }
  ${Component.fragment}
`,
    {
      options: () => {
        return {
          ssr: false
        };
      },
      props: ({ data: { loading, cart }, ownProps }) => {
        return {
          ...ownProps,
          loading,
          cart: cart || {}
        };
      }
    }
  )(Component);

withCart.displayName = 'withCart';

export default withCart;
